import { motion } from "framer-motion";

const EXECategories = () => {
  const categories = [
    {
      name: "School",
      description: "Students from schools or educational institutions",
      icon: <ion-icon name="library-outline"></ion-icon>,
      color: "text-exe-text-accent",
    },
    {
      name: "University",
      description: "Students from universities or higher education institutions",
      icon: <ion-icon name="school-outline"></ion-icon>,
      color: "text-exe-text-accent",
    },
  ];

  return (
    <section className="exe-section">
      <div className="exe-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="exe-title text-exe-text-accent mb-6">
            Competition Categories
          </h2>
          <div className="h-1 w-24 bg-exe-gradient-primary mx-auto mb-8"></div>
          <p className="exe-text text-xl">
            Choose your category and showcase your skills
          </p>
        </motion.div>

        <div className="grid md:grid-cols-1 lg:grid-cols-2 gap-8">
          {categories.map((category, index) => (
            <motion.div
              key={category.name}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="exe-glass-card p-8 text-center relative overflow-hidden group"
            >
              <div className="absolute inset-0 bg-exe-primary opacity-0 group-hover:opacity-5 transition-opacity duration-150"></div>

              <div className="relative z-10">
                <div className="text-5xl mb-4">{category.icon}</div>
                <h3 className={`exe-heading mb-4 ${category.color}`}>
                  {category.name}
                </h3>
                <p className="exe-text text-sm">{category.description}</p>
              </div>

              <div className="absolute bottom-2 right-2 w-16 h-16 bg-exe-circuit-pattern opacity-5"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EXECategories;
